<template>
    <tr class="role">
            <td class="name">{{role.display_name}}</td>
            <td class="name">{{role.name}}</td>
            <td class="description">{{role.description}}</td>
            <td class="actions">
                <div class="edit action" data-toggle="modal" :data-target="'#modal-'+role.id"><i class="fas fa-edit"></i></div>
                <div class="action" @click="deleteRole()"><i class="far fa-trash-alt"></i></div>
                <div class="modal fade" tabindex="-1"  :id="'modal-'+role.id" ref="vuemodal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-primary text-white">
                                <h5 class="modal-title">Lomas labošana</h5>
                                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="modalMenu">
                                    <div class="modalMenuItem" @click="changeStep(1)" :class="{'active': step === 1}">Loma</div>
                                    <div class="modalMenuItem" @click="changeStep(2)" :class="{'active': step === 2}">Atļaujas</div>
                                </div>
                                <div class="row">
                                <div v-if="step == 1" :class="{'active': step === 1}" class="col-12">
                                    <div class="form-group">
                                        <label for="display_name">Nosaukums</label>
                                        <input type="text" v-model="display_name" class="form-control" :class="{'is-invalid':errors && ( 'display_name' in errors)}" >
                                        <small class="text-danger" v-if="errors && errors.display_name">{{errors.display_name[0]}}</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="name">Programmatiskais nosaukums</label>
                                        <input type="text" v-model="name" class="form-control" :class="{'is-invalid':errors && ( 'name' in errors)}" >
                                        <small class="text-danger" v-if="errors && errors.name">{{errors.name[0]}}</small>
                                        <small class="text-muted" v-else>Nosaukums bez atstarpēm, mīkstinājuma un garumzīmēm</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="description">Apraksts</label>
                                        <input type="text" v-model="description" class="form-control" :class="{'is-invalid':errors && ( 'description' in errors)}" >
                                        <small class="text-danger" v-if="errors && errors.description">{{errors.description[0]}}</small>
                                    </div>
                                </div>
                                <div v-if="step == 2" class="col-12">
                                    <div class="permissionsFilter">
                                        <select name="permissionsFilter" id="permissionsFilter" class="form-control" v-model="selectedPermissionGroup">
                                            <option value="0" selected>Visas atļaujas</option>
                                            <option v-for="group in groups" :value="group.id">{{group.name}}</option>
                                        </select>
                                        <hr>
                                    </div>
                                    <div class="permissions">
                                        <div v-for="permission in permissions" :key="permission.id" class="permission" v-if="selectedPermissionGroup == 0 || selectedPermissionGroup == permission.permission_group_id">
                                            <div class="name">{{permission.display_name}}</div>
                                            <div class="actions">
                                                 <span  v-if="activePermissions.includes(permission.name)" @click="removePermission(permission.id)" class="switch" :class="{'active':activePermissions.includes(permission.name)}">
                                                    <span class="circle">
                                                        &nbsp;
                                                    </span>
                                                </span>
                                                <span v-else @click="addPermission(permission.id)" class="switch">
                                                    <span class="circle">
                                                        &nbsp;
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                            </div>
                            <div class="modal-footer">
                                <input type="button" class="btn btn-success" value="Saglabāt" v-if="loading == false" @click="updateRole()">
                                <button type="button" class="btn btn-success"  v-if="loading == true"><i class="fas fa-spinner fa-spin"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </td>
    </tr>
</template>

<script>
    export default {
        props:['role','permissions','groups'],
        mounted()
        {
            this.name = this.$props.role.name;
            this.display_name = this.$props.role.display_name;
            this.description = this.$props.role.description;
            this.id = this.$props.role.id;



        },
        data() {
            return {
                loading: false,
                errors: null,
                name:null,
                display_name: null,
                description:null,
                step:1,
                selectedPermissionGroup:0,


            }
        },
        computed:{
            activePermissions: function()
            {
                var permissions = [];
                this.role.permissions.forEach(permission =>
                {
                    permissions.push(permission.name);
                });

                return permissions;

            }
        },
        methods: {
            changeStep(step)
            {
                this.step = step;
            },
            removePermission(id)
            {
                var that = this;
                axios.post('/dashboard/api/role/'+that.role.id+'/removePermission/'+id)
                    .then(response =>
                    {
                        if(response.data.status == 'ok')
                        {
                            that.role = response.data.role;
                            that.$toast.open(response.data.message);
                        }
                    });
            },
            addPermission(id)
            {
                    var that = this;
                    axios.post('/dashboard/api/role/'+that.role.id+'/addPermission/'+id)
                        .then(response =>
                        {
                            if(response.data.status == 'ok')
                            {
                                that.role = response.data.role;
                                that.$toast.open(response.data.message);
                            }
                        });
            },
            deleteRole()
            {
                var that = this;
                this.$swal.fire({
                    title: 'Vai tiešām vēlaties dzēst lomu?',
                    text: "Loma tiks noņemta visiem lietotājiem un neatgriezeniski dzēsta!",
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Jā',
                    cancelButtonText: 'Atcelt'
                }).then((result) => {
                    if(result.value)
                    {
                        axios.post('/dashboard/api/roles/'+that.id+'/delete')
                            .then(response =>{
                                if(response.data.status == 'ok') {
                                     EventBus.$emit('roles_updated', response.data.roles);
                                    that.$toast.open(response.data.message);
                                }
                                else
                                {
                                    that.$toast.open(response.data.message);
                                }
                            });
                    }
                })

            },
            updateRole()
            {
                var that = this;
                this.loading = true;
                axios.post('/dashboard/api/roles/'+that.id,{
                    name: this.name,
                    display_name: this.display_name,
                    description:this.description,

                }).then(response =>{
                    that.loading = false;
                    if (response.data.status == 'ok')
                    {
                         EventBus.$emit('roles_updated', response.data.roles);
                        that.$toast.open(response.data.message);
                        $(that.$refs.vuemodal).modal('hide');
                    }

                    if (response.data.status == 'error')
                    {
                        that.errors = response.data.errors;
                    }



                })
            }
        }

    }
</script>

<style lang="scss" scoped>
@use "sass:color";
@import '../../sass/variables';
    .switch{
        width:45px;
        height:25px;
        background:#eee;
        border-radius:15px;
        position:relative;
        .circle{
            position:absolute;
            top:2.5px;
            left:2.5px;
            height:20px;
            width:20px;
            background:#fff;
            border-radius:100%;
            transition:all .2s ease-in-out;
        }
        &.active{
            .circle{
                transform:translateX(17.5px);
                background:$blue;
            }
            &.green{
                .circle{
                    background:$green;
                }
            }
        }
    }
    .permissions{
        .permission{
            padding:10px;
            display:flex;
            border-bottom: 1px #eee solid;
            .name{
                font-weight:bold;
                display:flex;
                align-items: center;
            }
            .actions{
                display:flex;
                align-items: center;
                cursor: pointer;
                .roleCol{
                    cursor: pointer;
                    text-align: center;
                    padding:10px;
                    display:flex;
                    align-items: center;
                    .active{
                        color:$blue;
                        display:flex;
                        align-items: center;
                    }
                    .inactive{
                        color:#aaa;
                        display:flex;
                        align-items: center;
                    }
                }
                margin-left:auto;
            }
        }
    }
    .name{
        min-width:150px;
    }
    .description{
        min-width:350px;
    }
    .actions{
        display:flex;
        .action{
            padding:10px;
        }

    }

</style>
